import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/contacts', params),
    getById: (id) => Api.get('/cent/contact/' + id, null),
    save: (entity) => Api.post('/cent/contact', entity),
    update: (id, entity) => Api.put('/cent/contact/' + id, entity),
    delete: (id) => Api.delete('/cent/contact/' + id),
    search: function(searchText, params) {
        if (!params) params = {};
        params.q = searchText;
        return Api.get('/cent/contacts/search', params);
    },
};